import { render, staticRenderFns } from "./TikTok.vue?vue&type=template&id=6dfcaee8&scoped=true&"
import script from "./TikTok.vue?vue&type=script&lang=js&"
export * from "./TikTok.vue?vue&type=script&lang=js&"
import style0 from "./TikTok.vue?vue&type=style&index=0&id=6dfcaee8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfcaee8",
  null
  
)

export default component.exports